module.exports = __webpack_public_path__ + "static/media/notificacao-patrocinada.712d7f5c.png";